import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const ShopifyFailure = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        background: "linear-gradient(135deg, #fef3c7 0%, #fecaca 100%)",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          background: "white",
          borderRadius: "20px",
          padding: "60px 40px",
          textAlign: "center",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.8)",
        }}
      >
        {/* Error Icon */}
        <ErrorIcon
          sx={{
            fontSize: "80px",
            color: "#ef4444",
            marginBottom: "24px",
            animation: "shake 0.5s infinite",
            "@keyframes shake": {
              "0%, 100%": { transform: "translateX(0)" },
              "25%": { transform: "translateX(-5px)" },
              "75%": { transform: "translateX(5px)" },
            },
          }}
        />

        {/* Error Message */}
        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1f2937",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          Connection Failed
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: "16px",
            color: "#6b7280",
            marginBottom: "32px",
            lineHeight: "1.6",
            fontWeight: "500",
          }}
        >
          Something went wrong while connecting your Shopify store. Please check your credentials and try again.
        </Typography>

        {/* Retry Button */}
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/pos-sync/configure")}
          sx={{
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            color: "white",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: "600",
            padding: "12px 32px",
            borderRadius: "10px",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 10px 25px rgba(239, 68, 68, 0.3)",
            },
          }}
        >
          Try Again
        </Button>
      </Box>
    </Box>
  );
};

export default ShopifyFailure;

